<template>  <svg
    role="img"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-search icon--full-color"
    aria-label="Search"
  >
    <path
      d="M24 24L19.1667 19.1667M21.7778 12.8889C21.7778 17.7981 17.7981 21.7778 12.8889 21.7778C7.97969 21.7778 4 17.7981 4 12.8889C4 7.97969 7.97969 4 12.8889 4C17.7981 4 21.7778 7.97969 21.7778 12.8889Z"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>